import { gql, useApolloClient, useMutation } from '@apollo/client';
const DOSSIER_UPDATE_PARAMETERS = gql`
  mutation dossierUpdateParameters($id: Long, $parameters: [ParameterFormDtoInput]) {
    dossier_updateParameters(id: $id, parameters: $parameters) {
      id
    }
  }
`;
export const useDossierUpdateParametersMutation = options => useMutation(DOSSIER_UPDATE_PARAMETERS, options);
export const useDossierUpdateParametersMutationPromise = () => {
  const client = useApolloClient();
  return variables => client.mutate({
    mutation: DOSSIER_UPDATE_PARAMETERS,
    variables
  });
};